export const SIZES = {
  EXTRA_LARGE: 1100,
  EXTRA_LARGE_WIDE: 1300,
  EXTRA_SMALL: 300,
  LARGE: 900,
  MEDIUM: 700,
  SMALL: 500,
};
